import { useLocalStorage } from '@rehooks/local-storage';
import { useEffect } from 'react';

export const useGuestAccessHashBase = (selector, search) => {
    const [guestAccessHash, setGuestAccessHash] = useLocalStorage(selector, null);

    const queryParams = new URLSearchParams(search);
    const queryGuestAccessHash = queryParams.get('guest-access-hash');
    const shouldReturnStoredGuestAccessHash = !queryGuestAccessHash || queryGuestAccessHash === guestAccessHash;

    useEffect(() => {
        if (queryGuestAccessHash && !shouldReturnStoredGuestAccessHash) {
            setGuestAccessHash(queryGuestAccessHash);
        }
    }, [queryGuestAccessHash, setGuestAccessHash]);

    return {
        guestAccessHash: shouldReturnStoredGuestAccessHash ? guestAccessHash : null,
    };
};
